import { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { PrivateRoute } from 'store/context/auth/private-route';

export const getRoutes = (allRoutes) =>
  allRoutes.map((route) => (
    <Fragment key={route.name}>
      {route.name === 'Authentication' ? (
        <Route
          exact
          path={route.route}
          element={route.component}
          key={route.name}
        />
      ) : (
        <Route element={<PrivateRoute name={route.name} />}>
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.name}
          />
        </Route>
      )}
    </Fragment>
  ));
